// React Imports
import React from 'react';

// Mui Imports
import {Avatar, Tooltip} from '@mui/material';
import {GRID_DETAIL_PANEL_TOGGLE_FIELD} from "@mui/x-data-grid-pro";
import {deepOrange, green} from "@mui/material/colors";

// App Imports
import WorkIssuanceStatusMenu from "../Status/WorkIssuanceStatusMenu";


// main function
export const WorkIssuancePaymentGridColumns = ({ hideActions,  handleMousedRow, handleClickedRow }) => [

    // ***************** BEGIN COLUMNS ***************************

    {
        field: 'id',
        headerName: 'id',
        description: '',
        sortable: true,
        editable: true,
        width: 60,
        hide: true
    },

    {
        field: 'reuseMarket',
        headerName: 'Reuse Market',
        description: '',
        sortable: false,
        editable: true,
        width: 300,

    },
    {
        field: 'dataPointName',
        headerName: 'Data Point',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        width: 400,
        hide: false,
        renderCell: (contractDataPoints) => {
            return (
                <Tooltip  enterDelay={1000} enterNextDelay={1000}  title={<span style={{whiteSpace: 'pre-line'}}>
                    {"dp id: " + contractDataPoints.row.dataPointId +
                        "\ncdp id: " + contractDataPoints.row.cdpId +
                        "\ncdpv id: " + contractDataPoints.row.cdpvId +
                        "\nhierarchy: " + contractDataPoints.row.hierarchy +
                        "\nhierarchy order: " + contractDataPoints.row.hierarchyOrder +
                        "\nhierarchy level: " + contractDataPoints.row.hierarchyLevel
                        // "\nsource section id: " + workQueueCDP.row.sourceContractSectionId +
                        // "\nsource contract data point id: " + workQueueCDP.row.sourceContractDataPointId
                    }</span>}>
                    <div className="rowitem"
                         onClick= {() => handleClickedRow(contractDataPoints.row)}
                        // onClick= {() => handleExpression(workQueueCDP.row.id,  workQueueCDP.row.contractSectionId, fetchWorkQueueCDP)}
                         style={{cursor:'pointer'}}
                    >{contractDataPoints.row.dataPointName}</div></Tooltip>)}
    },
    //
    {
        field: 'cdpId',
        headerName: 'cdpId',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },
    {
        field: 'dataPointId',
        headerName: 'dataPointId',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },

    {
        field: 'currentAmount',
        headerName: 'raw currentAmount',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        width: 80,
        hide: true
    },
    {
        field: 'displayValue',
        headerName: 'Payment',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        align: 'right', // aligns cell content
        headerAlign: 'right', // optional: aligns header text too
        width: 120,
        hide: false
    },
    {

        field: GRID_DETAIL_PANEL_TOGGLE_FIELD,
        type: 'actions',  // Required for built-in expand behavior
        headerName: 'Expression',
        renderCell: (contracts) =>
        {
            if((contracts.row.expression !== null) && (contracts.row.expression !== '')){
                return (
                    <Tooltip title={"Value comes from an expression.  Click to see."}>
                        <Avatar sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepOrange[500] }}>e</Avatar>
                    </Tooltip>)}
        },
        description: '',
        sortable: false,
        width: 90,
    },
    // {
    //     field: "more",
    //     headerName: '',
    //     width: 20,
    //     padding: 0,
    //     margin: 0,
    //     sortable: false,
    //     menu: false,
    //     filter: false,
    //     hide: false,
    //     renderCell: (contracts) => {
    //         const rowCdpStatus = contracts.row.cdpStatus;
    //         return (<div onMouseOver={() => handleMousedRow(contracts.row)}>
    //                 {/*// <MoreHorizIcon fontSize={'small'} onClick= {() => handleControls()}/>*/}
    //                 <OwedStatusMenu rowCdpStatus={rowCdpStatus}/>
    //             </div>
    //         );
    //     }
    // }
    //   ,
    {    field: 'contractId',
        headerName: 'Contract ID',
        description: '',
        sortable: true,
        width: 60,
        hide: true
    },
    {
        field: 'contractName',
        headerName: 'On Contract',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        // editable: true,
        width: 350,
        hide: false
    },
    {
        field: 'dataType',
        headerName: 'dataType',
        description: '',
        sortable: false,
        editable: true,
        width: 100,
        hide: true
    },
    {
        field: 'sourceType',
        headerName: 'sourceType',
        description: '',
        sortable: false,
        editable: true,
        width: 100,
        hide: true
    },
    {
        field: 'dataPointRange',
        headerName: 'Range',
        description: '',
        sortable: false,
        editable: true,
        width: 80,
        hide: true
    },
    {
        field: 'cdpId',
        headerName: 'CDP ID',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },
    {
        field: 'cdpvId',
        headerName: 'CDPV ID',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },
    {
        field: 'iterationNumber',
        headerName: '#',
        description: '',
        sortable: false,
        editable: true,
        width: 15,
        hide: true
    },

    {
        field: 'hierarchyLevel',
        headerName: 'hierarchyLevel',
        description: '',
        sortable: false,
        editable: true,
        width: 20,
        hide: true
    },
    {
        field: 'hierarchyOrder',
        headerName: 'hierarchyOrder',
        description: '',
        sortable: false,
        editable: true,
        width: 20,
        hide: true
    },
    {
        field: 'hierarchy',
        headerName: 'Hierarchy',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        width: 80,
        hide: true
    },

];

// *************** END COLUMNS *******************************
